module.exports = __webpack_public_path__ + "static/img/teacher_empty.7d1c0693.png";